import React, { useCallback } from "react";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import { inAppNavLinks } from "../../../utils/helpers/navHelpers";
import { mergeClassName } from "../../../utils/helpers";
import { BiChevronRight } from "react-icons/bi";
import customToast from "../../CustomToast";
import IncludeBadge from "./IncludeBadge";
import ApplicationsDropdown from "../../ApplicationsDropDown";

function ApplicationMenu() {
  const { appid } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;

  const clickHandler = useCallback(
    (
      e: React.MouseEvent<HTMLAnchorElement>,
      list: any,
      name: string,
      isComingSoon = false,
    ) => {
      e.preventDefault();

      if (isComingSoon) return;

      if (name === "config") {
        customToast.warning(
          <>You can only View Risks linked through Policies</>,
          { position: "top-right" },
        );
      }

      if (!appid || list === "#") return;
      const path: string = list.link(appid);
      navigate(path);
    },
    [appid, navigate],
  );

  return (
    <>
      <ApplicationsDropdown />
      <div
        data-tut="instextour__nav-navigation"
        className="row-start-3 row-end-4 md:pl-6 "
      >
        <ul className="flex flex-col gap-y-7">
          {inAppNavLinks.map(
            ({ icon, link, title, name, child, isComingSoon }) => {
              return (
                <li
                  key={name}
                  className={mergeClassName(
                    "relative",
                    pathname.includes(name)
                      ? "relative rounded-2xl text-[#0B112F] [&_svg]:text-blue-130"
                      : "text-[#797D8C]",
                  )}
                >
                  <NavLink
                    key={name}
                    to={isComingSoon ? "#" : link}
                    onClick={(e) => clickHandler(e, link, name, isComingSoon)}
                    className={({ isActive }) =>
                      mergeClassName(
                        "flex items-center justify-start gap-x-1 text-sm leading-4",
                        pathname.includes(name) ? "font-bold" : "font-normal",
                        isComingSoon &&
                          "cursor-not-allowed opacity-50 pointer-events-none",
                      )
                    }
                  >
                    <span className="flex flex-1 items-center gap-x-5">
                      {icon}
                      <span className="hidden md:inline-block">{title}</span>
                      {name === "include" && <IncludeBadge />}
                    </span>
                    {isComingSoon && (
                      <span className="text-[0.626rem] bg-red-500 px-4 py-1 text-white rounded-full ">
                        Soon
                      </span>
                    )}

                    {child && child.length > 0 && (
                      <span className="justify-self-end">
                        <BiChevronRight />
                      </span>
                    )}
                  </NavLink>
                  {pathname.includes(name) && child && (
                    <div className="relative flex flex-col pl-2 pt-4 before:absolute before:left-10 before:h-max before:w-0.5 before:bg-[#EFF1F7]">
                      {child.map((item) => (
                        <NavLink
                          key={item.name}
                          to={item.isComingSoon ? "#" : link}
                          onClick={(e) =>
                            clickHandler(
                              e,
                              item.link,
                              item.name,
                              item.isComingSoon,
                            )
                          }
                          className={({ isActive }) =>
                            mergeClassName(
                              "relative flex  items-center justify-start gap-x-5 py-3 pl-4 text-sm leading-4 before:absolute before:left-0 before:h-full before:w-0.5 before:bg-[#EFF1F7]",
                              pathname.includes(item.name)
                                ? "font-bold text-[#0B112F] before:bg-blue-130"
                                : "text-gray-10",
                              item.isComingSoon &&
                                "cursor-not-allowed opacity-50 pointer-events-none",
                            )
                          }
                        >
                          <span className="hidden md:inline-block">
                            {item.title}
                          </span>
                          {item.isComingSoon && (
                            <span className="text-[0.626rem] bg-red-500 px-4 py-1 text-white rounded-full">
                              Soon
                            </span>
                          )}
                        </NavLink>
                      ))}
                    </div>
                  )}
                </li>
              );
            },
          )}
        </ul>
      </div>
    </>
  );
}

export default ApplicationMenu;
